// src/layouts/AppShell.jsx
import { useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";

import { isAuthenticated, logout } from "../../utils/authStore";


import Footer from "./Footer";
import Header from "./Header";
import PatientLayout from "./PatientLayout";

export default function AppShell() {
  const navigate = useNavigate();
  const location = useLocation();
  const handleSignOut = () => {
    logout();
    navigate("/signin", { replace: true });
  }


  useEffect(() => {
    // Check if user is authenticated
    if (!isAuthenticated()) {
      // Redirect to login page and save the intended destination
      navigate("/signin", { 
        replace: true,
        state: { from: location }
      });
    }
  }, [navigate, location]);

  // Don't render the protected content if not authenticated
  if (!isAuthenticated()) {
    return null;
  }

  return (
    <div className="min-h-screen bg-bg text-text flex flex-col">
      <Header />
      <main className="flex-1 w-full px-4 md:px-6 lg:px-8 py-6">
        <PatientLayout onSignOut={handleSignOut}>
          <Outlet />
        </PatientLayout>
      </main>
      <Footer />
    </div>
  );
}